<template>
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.31988 1.37736L7.91699 5.08752C8.56651 6.01541 7.9027 7.29037 6.77007 7.29037L2.23124 7.29037C1.0986 7.29037 0.434788 6.01541 1.08431 5.08752L3.68142 1.37736C4.07952 0.808646 4.92178 0.808646 5.31988 1.37736Z"
      fill="#CCD2E3"
      class="fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  width: 0.5rem;
  height: 0.6rem;
}
.icon-active svg .fill {
  fill: #417ce9;
}
.icon-arrow-down svg {
  transform: rotate(180deg);
}
</style>
